import React from 'react'
import './SocialMedia.css'

function SocialMedia() {
    return (
        <>
            <ul className="social">
                <li>
                    <a href="https://github.com/BillDin">
                        <i className="fa fa-github"></i>
                    </a>
                </li>

                <li>
                    <a href="https://medium.com/@cd034">
                        <i className="fa fa-medium"></i>
                    </a>
                </li>

                <li>
                    <a href="https://www.linkedin.com/in/chengcheng-ding-45b588173/">
                        <i className="fa fa-linkedin"></i>
                    </a>
                </li>

            </ul>
        </>
    )
}

export default SocialMedia
